(() => {
  if (window.ldsHomeInitialized) return;
  window.ldsHomeInitialized = true;
  function init(scope=document) {
    scope.querySelectorAll('[data-home-books]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const controls = root.querySelector('[data-home-book-controls]');
      const panes = [...root.querySelectorAll('[data-home-pane]')];
      const links = [...root.querySelectorAll('[data-home-link]')];
      const buttons = [...root.querySelectorAll('[data-home-book]')];
      controls.hidden = false;
      function select(id) {
        panes.forEach(pane => pane.hidden = pane.dataset.homePane !== id);
        links.forEach(link => link.hidden = link.dataset.homeLink !== id);
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.homeBook === id)));
        const active = panes.find(pane => pane.dataset.homePane === id);
        if (active) root.querySelector('[data-home-book-name]').textContent = active.dataset.title;
      }
      buttons.forEach(button => button.addEventListener('click', () => select(button.dataset.homeBook)));
      root.addEventListener('lds:book-select', event => select(event.detail.id));
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const pane = event.target.closest('[data-home-pane]');
    if (!pane) return;
    const root = pane.closest('[data-home-books]');
    const button = [...root.querySelectorAll('[data-home-book]')].find(b => b.dataset.homeBook === pane.dataset.homePane);
    if (button) button.click();
  });
})();
